// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller

import { application } from "./application"

import CharityItemController from "./charity_item_controller.js"
application.register("charity-item", CharityItemController)

import CharitySearchController from "./charity_search_controller.js"
application.register("charity-search", CharitySearchController)

import CopyController from "./copy_controller.js"
application.register("copy", CopyController)

import DonationController from "./donation_controller.js"
application.register("donation", DonationController)

import DonationSliderController from "./donation_slider_controller.js"
application.register("donation-slider", DonationSliderController)

import DropdownMenuController from "./dropdown_menu_controller.js"
application.register("dropdown-menu", DropdownMenuController)

import ModalController from "./modal_controller.js"
application.register("modal", ModalController)

import RemoteFormController from "./remote_form_controller.js"
application.register("remote-form", RemoteFormController)

import SliderController from "./slider_controller.js"
application.register("slider", SliderController)

import ToggleController from "./toggle_controller.js"
application.register("toggle", ToggleController)

import TooltipController from "./tooltip_controller.js"
application.register("tooltip", TooltipController)

import NewTabController from "./new_tab_controller.js"
application.register("new-tab", NewTabController)

import FormOverrideController from "./form_override.js"
application.register("form-override", FormOverrideController)

import ScrollOnChangeController from "./scroll_on_change_controller.js"
application.register("scroll-on-change", ScrollOnChangeController)

import DonationTrackingController from "./donation_tracking_controller.js"
application.register("donation-tracking", DonationTrackingController)

import LogoCarouselController from "./logo_carousel_controller.js"
application.register("logo-carousel", LogoCarouselController)

import AnimateController from "./animate_controller.js"
application.register("animate", AnimateController)

import CountUpController from "./countup_controller.js"
application.register("countup", CountUpController)

import FAQController from "./faq_controller.js"
application.register("faq", FAQController)

import FreqcuencyController from "./frequency_controller.js"
application.register("frequency", FreqcuencyController)
